import { Injectable } from '@angular/core';
import { IInventoryService } from './inventory-api.interface';
import { FindInventoriesQueryDto } from './dtos/queries/find-inventories.query.dto';
import { FindInventoriesResponseDto } from './dtos/queries/find-inventories.response.dto';
import { FindInventoryNamesQueryDto } from './dtos/queries/find-inventory-names.query.dto';
import { FindInventoryNamesResponseDto } from './dtos/queries/find-inventory-names.response.dto';
import { CreateInventoryRequestDto } from './dtos/commands/create-inventory.request.dto';
import { CreateInventoryResponseDto } from './dtos/commands/create-inventory.response.dto';
import { UpdateInventoryRequestDto } from './dtos/commands/update-inventory.request.dto';
import { UpdateInventoryResponseDto } from './dtos/commands/update-inventory.response.dto';
import { FindInventoryResponseDto } from './dtos/queries/find-inventory.response.dto';

@Injectable({
  providedIn: 'root',
})
export class InventoryMockApiService implements IInventoryService {
  createInventory(data: CreateInventoryRequestDto): Promise<CreateInventoryResponseDto> {
    throw new Error('Method not implemented.');
  }
  updateInventory(inventoryId: number, data: UpdateInventoryRequestDto): Promise<UpdateInventoryResponseDto> {
    throw new Error('Method not implemented.');
  }
  findInventories(query: FindInventoriesQueryDto): Promise<FindInventoriesResponseDto> {
    throw new Error('Method not implemented.');
  }
  findInventoryNames(query: FindInventoryNamesQueryDto): Promise<FindInventoryNamesResponseDto> {
    throw new Error('Method not implemented.');
  }
  findInventory(inventoryId: number): Promise<FindInventoryResponseDto> {
    throw new Error('Method not implemented.');
  }
  deleteInventory(inventoryId: number): Promise<{ deletedCount: number; deletedIds: number[]; }> {
    throw new Error('Method not implemented.');
  }
  deleteInventories(inventoryIds: number[]): Promise<{ deletedCount: number; deletedIds: number[]; }> {
    throw new Error('Method not implemented.');
  }
}
